import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3ga4euf8eq: FaireBrandEntity = {
  token: "b_3ga4euf8eq",
  type: "brand",
  name: "Andaluca",
  avatarUrl:
    "https://cdn.faire.com/fastly/a8ae6c14ba5ba3ef86a586b8ea1137f841a062f151a2eb516e2502cbd5948cd5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/02514071eba07b76a05fddac5c9eee8ae98e08c4271530bd03e9f7d2867f0044.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a8ae6c14ba5ba3ef86a586b8ea1137f841a062f151a2eb516e2502cbd5948cd5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/02514071eba07b76a05fddac5c9eee8ae98e08c4271530bd03e9f7d2867f0044.jpeg",
  location: "Oxnard, CA, USA",
  minimumOrderDollars: 205,
  rating: 4.9,
  reviewCount: 1741,
  isTopShop: true,
  isInsider: true,
  description:
    "Andaluca was created from our team's love for natural botanical creations and fragrance to be used as your home's finishing touch. Our team has been making and innovating in the home fragrance industry for the last 20 years and we are driven to create the world's best home fragrance products and always make our products in California just north of Los Angeles.\n\nOur name is inspired by the Andalucia region of southern Spain, where there are some of the most beautiful mountain side villages surrounded by gorgeous waterfalls and forestry all around. This picturesque landscape filled with natural beauty is perfectly fitting for our brand identity of using natural botanicals to create wonderful home creations.\n\nWe are devoted to redefining home fragrance to beautify your home both in scent and style, priding ourselves in quality and always made in California.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:44:59.676Z",
    importedBy: "entity-db-cli",
  },
};
